
export const CUSTOM_METRICS = {
  Crash: {
    KEY: 'B_APP_SHOP_NOAUTH',
  },
}
